import { useState, useEffect } from "react";

export const usePreviousPageDetect = () => {
  const [previousPage, setPreviousPage] = useState("");

  useEffect(() => {
    typeof document !== "undefined" && setPreviousPage(document.referrer);
  }, []);

  return { previousPage };
};
